import * as types from 'store/types';

export const setAirportContext = (dispatch, airportSlug) => {
	dispatch({
		type: types.AIRPORT_SET_CONTEXT,
		payload: airportSlug,
	});
}

export const resetAirportContext = (dispatch) => {
	dispatch({
		type: types.AIRPORT_RESET_CONTEXT
	});
}
